// GET
export const GET_SUBSCRIBER_DETAILS = '/subscriber/details';
export const GET_SUBSCRIBER_PRODUCTS_UUIDS = '/subscriber/products/uuids';
export const GET_SUBSCRIBER_IN_LOCAL = '/subscriber/inLocal';
export const GET_SUBSCRIBER_ACTIVE_DEVICES = '/subscriber/devices/active?order[0][column]=9&order[0][dir]=desc';

// POST
export const POST_SUBSCRIBER_LOGIN_API = '/subscriber/login';
export const POST_SUBSCRIBER_LOGIN_EXTERNAL_API = '/subscriber/login/external';
export const POST_SUBSCRIBER_LOGOUT = '/subscriber/logout';
export const POST_SUBSCRIBER_DEVICE_NAME = '/subscriber/device/name';
export const POST_SUBSCRIBER_AGREEMENTS_ACCEPT = '/subscriber/agreements/accept';
export const POST_MULTIPLE_ACCOUNT_LOGIN_API = '/subscriber/login/multipleAccount';

// PUT
export const PUT_SUBSCRIBER_DEVICE_TOGGLE = '/subscriber/device/toggle';
export const PUT_SUBSCRIBER_HIDE_UNAVAILABLE = '/subscriber/hide/unavailable';

export enum SubscriberApi {
	ActiveDevices = '/subscriber/devices/active',
	AddressGet = '/subscriber/address/get',
	AddressUpdate = '/subscriber/address/update',
	AgreementsAccept = '/subscriber/agreements/accept',
	Details = '/subscriber/details',
	DeviceName = '/subscriber/device/name',
	DeviceToggle = '/subscriber/device/toggle',
	HideUnavailable = '/subscriber/hide/unavailable',
	InLocal = '/subscriber/inLocal',
	Login = '/subscriber/login',
	LoginExternal = '/subscriber/login/external',
	LoginMultipleAccount = '/subscriber/login/multipleAccount',
	LoginOneTimeToken = '/subscriber/login/byOneTimeToken',
	Logout = '/subscriber/logout',
	PersonalDataGet = '/subscriber/profile/get/personalData',
	PersonalDataUpdate = '/subscriber/profile/update/personalData',
	ProductsUuids = '/subscriber/products/uuids',
	ParentalDisable = '/subscriber/parental/disable',
	ParentalEnable = '/subscriber/parental/enable',
	VerificationDocumentUpload = '/subscriber/verification/document/upload',
	InPoland = '/subscriber/inPoland',
	InEog = '/subscriber/inEog'
} 
